export default __webpack_public_path__ + "static/favicon-e6dac293f88ac44345b2c0204e2fcce1.ico";